'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Collapse = require('react-bootstrap/lib/Collapse');

var _Collapse2 = _interopRequireDefault(_Collapse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Collapse2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Collapse.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Collapse.js
 ** module chunks = 0
 **/